import { EditRowActionOptions } from 'components/CIMSTable/CIMSTableContext/types/actions/row'
import { IssueType } from '../../IssueTypesContext/types'
import { EditFormItemsValues } from '../../components/CreateEditFormItems/types'
import { Permission, notEqual } from 'shared'
import CreateEditFormItems from '../../components/CreateEditFormItems'
import { useIssueTypesContext } from '../../IssueTypesContext'
import { useEditIssueTypeMutation } from 'schema'
import { simpleEditNotification } from 'hooks/notificationHandler'
import { DefaultMutationHookOptions } from 'utils/defaults'

export function useEdit(): EditRowActionOptions<
  IssueType,
  EditFormItemsValues
> {
  const { refetch } = useIssueTypesContext()
  const [edit] = useEditIssueTypeMutation({
    ...DefaultMutationHookOptions,
    onCompleted: ({
      editIssueType: {
        type: { name },
      },
    }) => simpleEditNotification(name),
  })
  return {
    permission: Permission.EditIssueType,
    modal: {
      type: 'simple',
      body: <CreateEditFormItems />,
      recordName: 'name',
      initialValues: ({
        name,
        description,
        nonApplicableIssueDispositionTypes,
      }) => ({
        name,
        description,
        nonApplicableDispositionTypes: nonApplicableIssueDispositionTypes.map(
          ({ id, name, description, deleted }) => ({
            label: name,
            value: id,
            deleted,
            tooltip: description,
          })
        ),
      }),
      onOk: async (
        { id, ...type },
        { description, nonApplicableDispositionTypes, name }
      ) => {
        if (
          description === type.description &&
          name === type.name &&
          !notEqual(
            nonApplicableDispositionTypes?.map(({ value }) => value.toString()),
            type.nonApplicableIssueDispositionTypes.map(({ id }) => id)
          )
        )
          return
        await edit({
          variables: {
            input: {
              id,
              description,
              name,
              nonApplicableIssueDispositionTypeIds:
                nonApplicableDispositionTypes?.map(({ value }) =>
                  value.toString()
                ),
            },
          },
        })
        refetch()
      },
    },
  }
}
